import { gsap } from "../../node_modules/gsap/index.js";
import { ScrollToPlugin } from "../../node_modules/gsap/ScrollToPlugin";
import { ScrollTrigger } from "../../node_modules/gsap/ScrollTrigger.js";

import "@lottiefiles/lottie-player";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

window.addEventListener('DOMContentLoaded', (event) => {
  let sections = gsap.utils.toArray("#mission ol li");

  let offset = () => {
    // only adjust the odd number xpercent for length on mobile
    if (sections[1].clientWidth > (window.innerWidth / 2)) {
      return 0;
    } else {
      return sections.length % 2;
    }
  }

  let scroller = gsap.to(sections, {
    xPercent: () => {
      return -100 * (sections.length - 1 - offset());
    },
    ease: "none",
    scrollTrigger: {
      trigger: "#mission",
      pin: true,
      scrub: 1,
      start: "center center",
      end: "+=4000",
      invalidateOnRefresh: true,
      snap: {
        snapTo: 1 / (sections.length - 1),
        duration: { min: 0.1, max: 0.5 },
        ease: "none",
        anticipatePin: 0.2,
        delay: 0
      },
      onLeave: () => {
        const player = document.querySelector("#shapes");
        player.getLottie().play();
      }
    }
  });

  /** Scroll when the arrow is clicked. **/
  document.querySelector("#inspo-scroll").addEventListener('click', function (event) {
    event.preventDefault();
    let firstSlide = document.querySelector("#mission ol li:nth-child(2)");
    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: firstSlide,
        offsetY: 20
      }
    });

  }, false);

  /** manually do the smooth scroll to top since ScrollTrigger disables smooth-scroll **/
  document.querySelector("#back-to-top").addEventListener("click", function (event) {
    event.preventDefault();
    scroller.scrollTrigger.disable();
    gsap.to(window, {
      duration: 1,
      scrollTo: 0,
      ease: "circ.inOut",
      onComplete: () => {
        scroller.scrollTrigger.enable();
      }
    });
  });
});
